import { configureStore } from '@reduxjs/toolkit'
import langReducer from './slices/langSlice'
import authReducer from './slices/authSlice'
import loginReducer from './slices/loginSlice'
import resetPasswordReducer from './slices/resetPasswordSlice'
import showHeaderRightReducer from './slices/showHeaderRightSlice'
import sliderGroupGetAllReducer from './slices/sliderGroupGetAllSlice'
import sliderGroupGetReducer from './slices/sliderGroupGetSlice'
import sliderGroupCreateReducer from './slices/sliderGroupCreateSlice'
import sliderGroupUpdateReducer from './slices/sliderGroupUpdateSlice'
import sliderGetAllByGroupReducer from './slices/sliderGetAllByGroupSlice'
import moduleGetAllByPageReducer from './slices/moduleGetAllByPageSlice'
import moduleGetAllReducer from './slices/moduleGetAllSlice'
import languageGetAllReducer from './slices/languageGetAllSlice'
import languageGetReducer from './slices/languageGetSlice'
import languageCreateReducer from './slices/languageCreateSlice'
import languageUpdateReducer from './slices/languageUpdateSlice'
import languageDeleteReducer from './slices/languageDeleteSlice'
import moduleGetReducer from './slices/moduleGetSlice'
import moduleSortReducer from './slices/moduleSortSlice'
import moduleCreateReducer from './slices/moduleCreateSlice'
import moduleUpdateReducer from './slices/moduleUpdateSlice'
import moduleDeleteReducer from './slices/moduleDeleteSlice'
import moduleFieldGetAllReducer from './slices/moduleFieldGetAllSlice'
import moduleFieldGetReducer from './slices/moduleFieldGetSlice'
import moduleFieldCreateReducer from './slices/moduleFieldCreateSlice'
import moduleFieldUpdateReducer from './slices/moduleFieldUpdateSlice'
import moduleFieldDeleteReducer from './slices/moduleFieldDeleteSlice'
import pageGetAllReducer from './slices/pageGetAllSlice'
import pageGetReducer from './slices/pageGetSlice'
import pageGetSlugReducer from './slices/pageGetSlugSlice'
import pageCreateReducer from './slices/pageCreateSlice'
import pageUpdateReducer from './slices/pageUpdateSlice'
import pageDeleteReducer from './slices/pageDeleteSlice'
import formGroupGetAllReducer from './slices/formGroupGetAllSlice'
import formGroupGetReducer from './slices/formGroupGetSlice'
import formGroupCreateReducer from './slices/formGroupCreateSlice'
import formGroupUpdateReducer from './slices/formGroupUpdateSlice'
import formGroupDeleteReducer from './slices/formGroupDeleteSlice'
import formGetAllReducer from './slices/formGetAllSlice'
import formGetReducer from './slices/formGetSlice'
import formCreateReducer from './slices/formCreateSlice'
import formUpdateReducer from './slices/formUpdateSlice'
import formDeleteReducer from './slices/formDeleteSlice'
import formElementGetAllReducer from './slices/formElementGetAllSlice'
import formElementGetReducer from './slices/formElementGetSlice'
import formElementCreateReducer from './slices/formElementCreateSlice'
import formElementUpdateReducer from './slices/formElementUpdateSlice'
import formElementDeleteReducer from './slices/formElementDeleteSlice'
import menuGetAllReducer from './slices/menuGetAllSlice'
import menuGetAllByGroupReducer from './slices/menuGetAllByGroupSlice'
import menuGetReducer from './slices/menuGetSlice'
import menuCreateReducer from './slices/menuCreateSlice'
import menuUpdateReducer from './slices/menuUpdateSlice'
import menuSortReducer from './slices/menuSortSlice'
import menuDeleteReducer from './slices/menuDeleteSlice'
import menuGroupGetAllReducer from './slices/menuGroupGetAllSlice'
import menuGroupGetReducer from './slices/menuGroupGetSlice'
import menuGroupCreateReducer from './slices/menuGroupCreateSlice'
import menuGroupUpdateReducer from './slices/menuGroupUpdateSlice'
import menuGroupDeleteReducer from './slices/menuGroupDeleteSlice'
import sliderGetAllReducer from './slices/sliderGetAllSlice'
import sliderGetReducer from './slices/sliderGetSlice'
import sliderCreateReducer from './slices/sliderCreateSlice'
import sliderUpdateReducer from './slices/sliderUpdateSlice'
import sliderDeleteReducer from './slices/sliderDeleteSlice'
import sliderSortReducer from './slices/sliderSortSlice'
import sliderContentGetAllReducer from './slices/sliderContentGetAllSlice'
import sliderContentGetAllBySliderReducer from './slices/sliderContentGetAllBySliderSlice'
import sliderContentGetReducer from './slices/sliderContentGetSlice'
import sliderContentCreateReducer from './slices/sliderContentCreateSlice'
import sliderContentUpdateReducer from './slices/sliderContentUpdateSlice'
import sliderContentDeleteReducer from './slices/sliderContentDeleteSlice'
import sliderContentSortReducer from './slices/sliderContentSortSlice'
import productGetAllReducer from './slices/productGetAllSlice'
import productGetReducer from './slices/productGetSlice'
import productCreateReducer from './slices/productCreateSlice'
import productUpdateReducer from './slices/productUpdateSlice'
import productDeleteReducer from './slices/productDeleteSlice'
import productSortReducer from './slices/productSortSlice'
import showcaseGetAllReducer from './slices/showcaseGetAllSlice'
import showcaseGetAllByProductReducer from './slices/showcaseGetAllByProductSlice'
import showcaseGetAllByAboutReducer from './slices/showcaseGetAllByAboutSlice'
import showcaseGetAllByNewsReducer from './slices/showcaseGetAllByNewsSlice'
import showcaseGetAllByPageReducer from './slices/showcaseGetAllByPageSlice'
import showcaseGetReducer from './slices/showcaseGetSlice'
import showcaseCreateReducer from './slices/showcaseCreateSlice'
import showcaseUpdateReducer from './slices/showcaseUpdateSlice'
import showcaseDeleteReducer from './slices/showcaseDeleteSlice'
import showcaseSortReducer from './slices/showcaseSortSlice'
import contactGetReducer from './slices/contactGetSlice'
import contactUpdateReducer from './slices/contactUpdateSlice'
import seoGetAllReducer from './slices/seoGetAllSlice'
import seoGetReducer from './slices/seoGetSlice'
import seoCreateReducer from './slices/seoCreateSlice'
import seoUpdateReducer from './slices/seoUpdateSlice'
import seoDeleteReducer from './slices/seoDeleteSlice'
import userChangePasswordReducer from './slices/userChangePasswordSlice'
import userCreateReducer from './slices/userCreateSlice'
import userDeleteReducer from './slices/userDeleteSlice'
import userGetAllReducer from './slices/userGetAllSlice'
import userGetReducer from './slices/userGetSlice'
import userUpdateReducer from './slices/userUpdateSlice'
import documentGetAllReducer from './slices/documentGetAllSlice'
import documentGetReducer from './slices/documentGetSlice'
import documentCreateReducer from './slices/documentCreateSlice'
import documentUpdateReducer from './slices/documentUpdateSlice'
import documentDeleteReducer from './slices/documentDeleteSlice'
import documentSortReducer from './slices/documentSortSlice'
import contentGetReducer from './slices/contentGetSlice'
import contentUpdateReducer from './slices/contentUpdateSlice'
import settingGetReducer from './slices/settingGetSlice'
import settingUpdateReducer from './slices/settingUpdateSlice'
import logGetAllReducer from './slices/logGetAllSlice'
import logGetReducer from './slices/logGetSlice'
import logDeleteReducer from './slices/logDeleteSlice'
import showcaseDesignReducer from './slices/showcaseDesignSlice'
import socialMediaGetAllReducer from './slices/socialMediaGetAllSlice'
import socialMediaGetReducer from './slices/socialMediaGetSlice'
import socialMediaCreateReducer from './slices/socialMediaCreateSlice'
import socialMediaUpdateReducer from './slices/socialMediaUpdateSlice'
import socialMediaDeleteReducer from './slices/socialMediaDeleteSlice'
import isTemplateReducer from './slices/isTemplateSlice'
import tabTemplateReducer from './slices/tabTemplateSlice'
import templateReducer from './slices/templateSlice'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        lang: langReducer,
        contactGet: contactGetReducer,
        contentGet: contentGetReducer,
        contentUpdate: contentUpdateReducer,
        contactUpdate: contactUpdateReducer,
        documentGetAll: documentGetAllReducer,
        documentGet: documentGetReducer,
        documentCreate: documentCreateReducer,
        documentUpdate: documentUpdateReducer,
        documentDelete: documentDeleteReducer,
        documentSort: documentSortReducer,
        formGetAll: formGetAllReducer,
        formGet: formGetReducer,
        formCreate: formCreateReducer,
        formUpdate: formUpdateReducer,
        formDelete: formDeleteReducer,
        formElementGetAll: formElementGetAllReducer,
        formElementGet: formElementGetReducer,
        formElementCreate: formElementCreateReducer,
        formElementUpdate: formElementUpdateReducer,
        formElementDelete: formElementDeleteReducer,
        formGroupGetAll: formGroupGetAllReducer,
        formGroupGet: formGroupGetReducer,
        formGroupCreate: formGroupCreateReducer,
        formGroupUpdate: formGroupUpdateReducer,
        formGroupDelete: formGroupDeleteReducer,
        isTemplate: isTemplateReducer,
        languageGetAll: languageGetAllReducer,
        languageGet: languageGetReducer,
        languageCreate: languageCreateReducer,
        languageUpdate: languageUpdateReducer,
        languageDelete: languageDeleteReducer,
        logGetAll: logGetAllReducer,
        logGet: logGetReducer,
        logDelete: logDeleteReducer,
        login: loginReducer,
        menuGetAll: menuGetAllReducer,
        menuGetAllByGroup: menuGetAllByGroupReducer,
        menuGet: menuGetReducer,
        menuCreate: menuCreateReducer,
        menuUpdate: menuUpdateReducer,
        menuSort: menuSortReducer,
        menuDelete: menuDeleteReducer,
        menuGroupGetAll: menuGroupGetAllReducer,
        menuGroupGet: menuGroupGetReducer,
        menuGroupCreate: menuGroupCreateReducer,
        menuGroupUpdate: menuGroupUpdateReducer,
        menuGroupDelete: menuGroupDeleteReducer,
        moduleGetAllByPage: moduleGetAllByPageReducer,
        moduleGetAll: moduleGetAllReducer,
        moduleGet: moduleGetReducer,
        moduleCreate: moduleCreateReducer,
        moduleUpdate: moduleUpdateReducer,
        moduleDelete: moduleDeleteReducer,
        moduleSort: moduleSortReducer,
        moduleFieldGetAll: moduleFieldGetAllReducer,
        moduleFieldGet: moduleFieldGetReducer,
        moduleFieldCreate: moduleFieldCreateReducer,
        moduleFieldUpdate: moduleFieldUpdateReducer,
        moduleFieldDelete: moduleFieldDeleteReducer,
        pageGetAll: pageGetAllReducer,
        pageGet: pageGetReducer,
        pageGetSlug: pageGetSlugReducer,
        pageCreate: pageCreateReducer,
        pageUpdate: pageUpdateReducer,
        pageDelete: pageDeleteReducer,
        productGetAll: productGetAllReducer,
        productGet: productGetReducer,
        productCreate: productCreateReducer,
        productUpdate: productUpdateReducer,
        productDelete: productDeleteReducer,
        productSort: productSortReducer,
        resetPassword: resetPasswordReducer,
        seoGetAll: seoGetAllReducer,
        seoGet: seoGetReducer,
        seoCreate: seoCreateReducer,
        seoUpdate: seoUpdateReducer,
        seoDelete: seoDeleteReducer,
        settingGet: settingGetReducer,
        settingUpdate: settingUpdateReducer,
        showcaseGetAll: showcaseGetAllReducer,
        showcaseGetAllByProduct: showcaseGetAllByProductReducer,
        showcaseGetAllByAbout: showcaseGetAllByAboutReducer,
        showcaseGetAllByNews: showcaseGetAllByNewsReducer,
        showcaseGetAllByPage: showcaseGetAllByPageReducer,
        showcaseGet: showcaseGetReducer,
        showcaseCreate: showcaseCreateReducer,
        showcaseUpdate: showcaseUpdateReducer,
        showcaseDesign: showcaseDesignReducer,
        showcaseDelete: showcaseDeleteReducer,
        showcaseSort: showcaseSortReducer,
        showHeaderRight: showHeaderRightReducer,
        sliderGetAllByGroup: sliderGetAllByGroupReducer,
        sliderGetAll: sliderGetAllReducer,
        sliderGetAllByGroup: sliderGetAllByGroupReducer,
        sliderGet: sliderGetReducer,
        sliderCreate: sliderCreateReducer,
        sliderUpdate: sliderUpdateReducer,
        sliderDelete: sliderDeleteReducer,
        sliderSort: sliderSortReducer,
        sliderContentGetAll: sliderContentGetAllReducer,
        sliderContentGetAllBySlider: sliderContentGetAllBySliderReducer,
        sliderContentGet: sliderContentGetReducer,
        sliderContentCreate: sliderContentCreateReducer,
        sliderContentUpdate: sliderContentUpdateReducer,
        sliderContentDelete: sliderContentDeleteReducer,
        sliderContentSort: sliderContentSortReducer,
        sliderGroupGetAll: sliderGroupGetAllReducer,
        sliderGroupGet: sliderGroupGetReducer,
        sliderGroupCreate: sliderGroupCreateReducer,
        sliderGroupUpdate: sliderGroupUpdateReducer,
        socialMediaGetAll: socialMediaGetAllReducer,
        socialMediaGet: socialMediaGetReducer,
        socialMediaCreate: socialMediaCreateReducer,
        socialMediaUpdate: socialMediaUpdateReducer,
        socialMediaDelete: socialMediaDeleteReducer,
        tabTemplate: tabTemplateReducer,
        template: templateReducer,
        userChangePassword: userChangePasswordReducer,
        userCreate: userCreateReducer,
        userDelete: userDeleteReducer,
        userGetAll: userGetAllReducer,
        userGet: userGetReducer,
        userUpdate: userUpdateReducer,
    },
});

export default store;
